import { render, staticRenderFns } from "./crossover-payment-method.component.vue?vue&type=template&id=6918ac78&"
import script from "./crossover-payment-method.component.vue?vue&type=script&lang=ts&"
export * from "./crossover-payment-method.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports